//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "SearchFilterItems",
	props: {
		executeSearch: Function,
		setFilterValue: Function,
		filter: Object
	},
	data() {
		return {
			url: null,
			mobileActive: false
		}
	},
	computed: {
		// ...mapGetters([]),
		model: {
			get() {
				return this.filter.selected;
			},
			set(value) {
				this.setFilterValue(this.filter, value);
				this.executeSearch();
			}
		},
	},
	methods: {
		...mapMutations([
			"setStateValue"
		]),
	},
	mounted() {
		
	},
};
